import {Request} from './Request';

export class DataTransferRequest implements Request {
    chargePointSelectList: string[];
    private vendorId: string;
    private messageId: string;
    private data: string;

    constructor(chargePointSelectList: string[], vendorId?: string, messageId?: string, data?: string) {
        this.chargePointSelectList = chargePointSelectList;
        this.vendorId = vendorId;
        this.messageId = messageId;
        this.data = data;
    }

    public toString = (): string => {
        return `DataTransferRequest (vendorId: ${this.vendorId},
        messageId: ${this.messageId}, data: ${this.data}`;
    }


    get vendor_id(): string {
        return this.vendorId;
    }

    set vendor_id(value: string) {
        this.vendorId = value;
    }

    get message_id(): string {
        return this.messageId;
    }

    set message_id(value: string) {
        this.messageId = value;
    }

    get _data(): string {
        return this.data;
    }

    set _data(value: string) {
        this.data = value;
    }
}
/*
* chargePointSelectList: JSON;EVB-P20261797;-
    chargePointSelectList: 1
vendorId: 1234
messageId: 4567
data: Hello Girish
*/
